import type { ReactNode } from 'react';
import { Button } from 'components/Button';
import { cn } from 'utils/classNamesTailwind';
import { useSelectClose } from './SelectContext';
import { selectFooterVariants } from './selectVariants';

interface SelectFooterProps {
  children: ReactNode;
  className?: string;
}

export function SelectFooter({ children, className = undefined }: SelectFooterProps) {
  return <div className={cn(selectFooterVariants(), className)}>{children}</div>;
}

export function SelectConfirmButton({ children }: { children: ReactNode }) {
  const close = useSelectClose();

  return (
    <Button size="sm" onClick={close ?? undefined}>
      {children}
    </Button>
  );
}
